import { Box, DialogContent, Divider } from "@mui/material";
import StageDialog from "../StageDialog";
import { MeetingDialogTitle } from "../widgets";
import { MediaDevicesContext, MediaDevicesHandler } from "@dvrt/web-phone-client";
import VideoPreview from "./VideoPreview";
import { WebClientUISettings } from "../contexts/selectedDevices";
import Footer from "./Footer";
import DisplayNameSetting from "./DisplayNameSetting";
import { VideoEffectContextProvider } from "../contexts/videoEffectContext";

const PreparationDialog = () => {
    const mediaDevicesHandler = new MediaDevicesHandler();

    return (
        <MediaDevicesContext.Provider value={mediaDevicesHandler}>
            <WebClientUISettings>
                <StageDialog>
                    <>
                        <MeetingDialogTitle />
                        <Box sx={{ padding: "0.5em 1em" }}>
                            <DisplayNameSetting />
                        </Box>
                        <Divider />
                        <DialogContent sx={{ display: "flex", justifyContent: "center" }}>
                            <VideoEffectContextProvider>
                                <VideoPreview />
                            </VideoEffectContextProvider>
                        </DialogContent>
                        <Divider />
                        <Footer />
                    </>
                </StageDialog>
            </WebClientUISettings>
        </MediaDevicesContext.Provider>
    );
};

export default PreparationDialog;
